export default __webpack_public_path__ + "static/media/phone-about-dark.169e8f85.jpg";